import React, { Component } from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import reduxFetch from 'react-redux-fetch';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { GetOrganisationId } from 'nallian-shared-ui/lib/selectors';
import apiRoutes from '../../../app/api/routes';

const mapStateToProps = state => ({
  organisationId: GetOrganisationId(state),
});

export default ComposedComponent => {
  class Vehicles extends Component {
    getPrivateVehiclesSearchForSelectOptions = () =>
      sortBy(
        (this.props.privateVehiclesSearchFetch.value &&
          this.props.privateVehiclesSearchFetch.value.values) ||
          [],
        'licensePlate'
      ).map(item => ({
        key: item.id,
        value: item.licensePlate,
        text: item.licensePlate,
      }));
    render() {
      return (
        <ComposedComponent
          {...this.props}
          getPrivateVehiclesSearchForSelectOptions={this.getPrivateVehiclesSearchForSelectOptions}
        />
      );
    }
  }

  Vehicles.propTypes = {
    privateVehiclesSearchFetch: PropTypes.object.isRequired,
  };

  return compose(
    connect(mapStateToProps),
    reduxFetch(({ organisationId }) => [
      {
        resource: 'privateVehiclesSearch',
        method: 'get',
        request: input => ({
          url: apiRoutes.searchPrivateVehicles({ organisationId, input }),
          comparison: new Date().toDateString() + input, // Only fetch once a day
        }),
      },
    ])
  )(Vehicles);
};
